import { combineReducers } from "redux";
import auth from "./auth";
import licensee from "./licensee";
import notification from "./notification";
import alert from "./alert";
import page from "./page";
import fields from "./field";
import person from "./person";
import product from "./product";
import invoice from "./invoice";

export default combineReducers({
  auth,
  alert,
  licensee,
  notification,
  page,
  fields,
  person,
  product,
  invoice
});
